function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M27.5 0C12.313 0 0 12.313 0 27.5c0 13.724 10.055 25.099 23.204 27.17V35.451h-6.986V27.5h6.986v-6.059c0-6.897 4.106-10.701 10.385-10.701 3.009 0 6.16.536 6.16.536v6.763h-3.476c-3.41 0-4.477 2.123-4.477 4.299v5.156h7.62L38.2 35.447h-6.403v19.218C44.945 52.604 55 41.227 55 27.5 55 12.313 42.687 0 27.5 0z"
});
function SvgFacebookFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 55 55",
    fill: "none"
  }, props), _ref);
}
export default SvgFacebookFilled;